<div class="flex items-center gap-4 px-4 py-2 bg-white border-b border-gray-200 shadow-sm dark:bg-gray-900 dark:border-gray-800">
  <!-- Survey info -->
  <div class="min-w-0 flex-1">
    <span class="block text-xs text-gray-500 dark:text-gray-400">{{survey?.id}}</span>
    <span class="block text-sm font-medium truncate text-gray-800 dark:text-white">{{survey?.name}}</span>
  </div>

  <!-- Tab buttons -->
  <nav class="flex items-center gap-1">
    <a [routerLink]="['/surveys', surveyId, 'builder']"
       routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
       class="rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
      Builder
    </a>
    <a [routerLink]="['/surveys', surveyId, 'cmd']"
       routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
       class="rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
      CMD
    </a>

    <!-- Translations dropdown: active when any of its pages is open -->
    <div class="relative" routerLinkActive #translationsActive="routerLinkActive">
      <button type="button"
              (click)="toggleTranslationsMenu()"
              [attr.aria-expanded]="openTranslationsMenu"
              aria-haspopup="menu"
              class="flex items-center gap-1 rounded-md px-3 py-1.5 text-sm font-medium transition-colors hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-gray-200"
              [class]="translationsActive.isActive
                ? 'bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400'
                : 'text-gray-600 dark:text-gray-400'">
        Translations
        <svg class="h-4 w-4 transition-transform" [class.rotate-180]="openTranslationsMenu" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
        </svg>
      </button>
      <!-- Kept in the DOM (hidden) so routerLinkActive above can see the links while the menu is closed. -->
      <div role="menu"
           [class.hidden]="!openTranslationsMenu"
           class="absolute right-0 z-50 mt-1 w-40 overflow-hidden rounded-md border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-900">
        <a role="menuitem"
           [routerLink]="['/surveys', surveyId, 'translations']"
           routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
           (click)="openTranslationsMenu = false"
           class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          Survey
        </a>
        <a role="menuitem"
           routerLink="/surveys/email-translations"
           routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
           (click)="openTranslationsMenu = false"
           class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          Email
        </a>
        <a role="menuitem"
           routerLink="/surveys/global-translations"
           routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
           (click)="openTranslationsMenu = false"
           class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          Global
        </a>
      </div>
    </div>

    <a [routerLink]="['/surveys', surveyId, 'fieldworks']"
       routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
       class="rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
      Fieldworks
    </a>
    <a [routerLink]="['/surveys', surveyId, 'businessrules']"
       routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
       class="rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
      Business Rules
    </a>
    <a [routerLink]="['/surveys', surveyId, 'alert']"
       routerLinkActive="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400"
       class="rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200">
      Alerts
    </a>
  </nav>
</div>
